import { ExportDataType } from '@conversed/shared/src/central/dto/export.dto';
import type React from 'react';
import { generate } from 'short-uuid';

import { useExportConfig } from '../../../../hooks/settings/exports/useExportConfig';
import { useExportConfigActions } from '../../../../hooks/settings/exports/useExportConfigActions';
import ExportConfigDataModal from './ExportConfigDataModal';

export const CreateExportConfigModal: React.FC = () => {
  const { createExportConfig } = useExportConfigActions();
  const { exportConfigs } = useExportConfig();

  const hasHistoryExport = exportConfigs.some(
    (config) => config.dataType === ExportDataType.History,
  );

  return (
    <ExportConfigDataModal
      onSubmit={createExportConfig}
      hasHistoryExport={hasHistoryExport}
      data={{
        id: generate(),
        isEnabled: true,
        name: '',
        format: 'xlsx',
        dataType: ExportDataType.Distinct,
        requiredFields: {},
        skipEmptyExport: true,
        isNonIncremental: true,
        exportTime: '08:00',
      }}
    />
  );
};

export default CreateExportConfigModal;
